const PAYSUCCESS = 'SUCCESS';
const ADMINREQUIRED = 'ADMIN_REQUIRED';

export { PAYSUCCESS, ADMINREQUIRED};
